<template>
  <div class="wxpay-config-container">
    <div class="header">
      <van-nav-bar title="微信支付配置" left-arrow @click-left="goBack" />
    </div>

    <div class="content">
      <van-loading v-if="loading" size="24px" vertical>加载中...</van-loading>

      <van-form @submit="handleSubmit" v-if="!loading">
        <van-cell-group title="基本信息">
          <van-field
            v-model="form.mch_id"
            name="mch_id"
            label="微信商户号"
            placeholder="请输入微信商户号"
            :rules="[{ required: true, message: '请输入微信商户号' }]"
          />
          
          <van-field
            v-model="form.app_id"
            name="app_id"
            label="小程序/AppID"
            placeholder="请输入小程序/AppID"
            :rules="[{ required: true, message: '请输入小程序/AppID' }]"
          />
        </van-cell-group>

        <van-cell-group title="安全配置">
          <van-field
            v-model="form.api_key"
            name="api_key"
            label="API密钥"
            type="password"
            placeholder="请输入API密钥"
            :rules="[{ required: true, message: '请输入API密钥' }]"
          />
        </van-cell-group>

        <van-cell-group title="回调配置">
          <van-field
            v-model="form.notify_url"
            name="notify_url"
            label="回调地址"
            placeholder="请输入回调地址"
            :rules="[{ required: true, message: '请输入回调地址' }]"
          />
        </van-cell-group>

        <van-cell-group title="状态设置">
          <van-field name="status" label="启用状态">
            <template #input>
              <van-switch v-model="form.status" size="20" />
            </template>
          </van-field>
        </van-cell-group>

        <div class="button-group">
          <van-button round block type="primary" native-type="submit">
            保存配置
          </van-button>
          <van-button round block type="info" @click="handleTest" style="margin-top: 12px;">
            测试连通性
          </van-button>
        </div>
      </van-form>

      <van-dialog v-model="showTestResult" title="测试结果" :show-confirm-button="false">
        <div class="test-result">
          <div v-for="(value, key) in testResult" :key="key" class="test-item">
            <span class="test-label">{{ getTestLabel(key) }}：</span>
            <span class="test-value">{{ value }}</span>
          </div>
          <van-button type="primary" block @click="showTestResult = false" style="margin-top: 20px;">
            关闭
          </van-button>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'WxpayConfig',
  data() {
    return {
      loading: true,
      form: {
        mch_id: '',
        api_key: '',
        app_id: '',
        notify_url: '',
        status: true
      },
      showTestResult: false,
      testResult: {}
    }
  },
  mounted() {
    if (!this.getAdminToken()) {
      this.loading = false
      Toast.fail('请先在「管理后台」登录，再打开微信支付配置')
      return
    }
    this.loadConfig()
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    async loadConfig() {
      this.loading = true
      try {
        const response = await this.$http.get('/api/admin/wxpay/config?admin_token=' + this.getAdminToken())
        const config = response.data.data.config
        
        if (config) {
          this.form = {
            mch_id: config.mch_id || '',
            api_key: config.api_key === '已设置' ? '' : (config.api_key || ''),
            app_id: config.app_id || '',
            notify_url: config.notify_url || '',
            status: config.status == 1
          }
        }
      } catch (err) {
        Toast.fail(err.message || '加载配置失败')
      } finally {
        this.loading = false
      }
    },
    async handleSubmit() {
      try {
        const data = {
          mch_id: this.form.mch_id,
          api_key: this.form.api_key,
          app_id: this.form.app_id,
          notify_url: this.form.notify_url,
          status: this.form.status ? 1 : 0
        }
        
        await this.$http.post('/api/admin/wxpay/config/save?admin_token=' + this.getAdminToken(), data)
        Toast.success('保存成功')
      } catch (err) {
        Toast.fail(err.message || '保存失败')
      }
    },
    async handleTest() {
      try {
        const response = await this.$http.post('/api/admin/wxpay/test?admin_token=' + this.getAdminToken())
        this.testResult = response.data.data.test_result
        this.showTestResult = true
      } catch (err) {
        Toast.fail(err.message || '测试失败')
      }
    },
    getTestLabel(key) {
      const labels = {
        mch_id: '微信商户号',
        app_id: '小程序/AppID',
        api_key: 'API密钥',
        notify_url: '回调地址',
        status: '启用状态'
      }
      return labels[key] || key
    },
    getAdminToken() {
      return localStorage.getItem('admin_token') || ''
    }
  }
}
</script>

<style scoped>
.wxpay-config-container {
  min-height: 100vh;
  background: #f8f9ff;
}

.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.content {
  padding: 16px;
}

.button-group {
  margin-top: 24px;
  padding: 0 16px;
}

.test-result {
  padding: 20px;
}

.test-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.test-item:last-child {
  border-bottom: none;
}

.test-label {
  font-size: 14px;
  color: #666;
}

.test-value {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
</style>
